const abusaad = require("../assets/images/speakers/AbuSaad.webp");
const Ahmed_Tohamy = require("../assets/images/speakers/Ahmed_Tohamy.webp");
const Alfy = require("../assets/images/speakers/Alfy.webp");
const Amira_Badran = require("../assets/images/speakers/Amira_Badran.webp");
const Amr_saleh = require("../assets/images/speakers/Amr_saleh.webp");
const Saad_Saleh = require("../assets/images/speakers/Saad_Saleh.webp");
const amani_hassan = require("../assets/images/speakers/amani_hassan.webp");
const ashraf_bany_mohamed = require("../assets/images/speakers/ashraf_bany_mohamed.webp");
const aya = require("../assets/images/speakers/aya.webp");
const azzeh = require("../assets/images/speakers/azzeh.webp");
const bassem = require("../assets/images/speakers/bassem.webp");
const farghal = require("../assets/images/speakers/farghal.webp");
const habiba_gaddalah = require("../assets/images/speakers/habiba_gaddalah.webp");
const hend_ismail = require("../assets/images/speakers/hend_ismail.webp");
const hithem_ahmed = require("../assets/images/speakers/hithem_ahmed.webp");
const jeff = require("../assets/images/speakers/jeff.webp");
const marwan_naggar = require("../assets/images/speakers/marwan_naggar.webp");
const mohab_mohie = require("../assets/images/speakers/mohab_mohie.webp");
const mostafa_men = require("../assets/images/speakers/mostafa_men.webp");
const noor_korayem = require("../assets/images/speakers/noor_korayem.webp");
const oriette = require("../assets/images/speakers/oriette.webp");
const maher_khayyat = require("../assets/images/speakers/maher_khayyat.jpg");
const wejdan = require("../assets/images/speakers/wejdan.webp");
const amr_ali = require("../assets/images/speakers/amr_ali.jpeg");
const abdo = require("../assets/images/speakers/abdo.jpg");
const adham_fahmy = require("../assets/images/speakers/adham_fahmy.webp");
const Haitham_raj = require("../assets/images/speakers/Haitham_raj.jpg");
const andy_hoa = require("../assets/images/speakers/andy_hoa.jpeg");
export const Speakers = [
    {
        id: 1,
        name: "Prof. Wejdan Abu Elhaija",
        title: "PSUT University President ",
        photo: wejdan,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll",
        onlinePresence: {
            facebook: "https://www.google.com",
            linkedin: "https://www.google.com",
            twitter: "https://www.google.com",
            instagram: "https://www.google.com"
        }
    },
    {
        id: 3,
        name: "Aya Elgebeely",
        title: "Founder & CEO at Talents Arena",
        photo: aya,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },

    {
        id: 5,
        name: "Prof. Mohammad Azzeh",
        title: "Professor at King Hussein School of Computing Sciences - PSUT",
        photo: azzeh,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 6,
        name: "Maher Al-Khyat",
        title: "Regional Business Applications GTM Director Innovation @Microsoft",
        photo: maher_khayyat,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 7,
        name: "Ashraf Bany Mohammed",
        title: "Vice dean of Business School - The University of Jordan ",
        photo: ashraf_bany_mohamed,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 8,
        name: "Mohammed Abusaad",
        title: "Staff Platform Engineer @Abwaab",
        photo: abusaad,
        country: "egypt",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 9,
        name: "Oriette NAYEL",
        title: "Project Executive, CHQ, Communications, IBM",
        photo: oriette,
        country: "ksa",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 10,
        name: "Ahmed Mohsen",
        title: "CTO @Halan",
        photo: Ahmed_Tohamy,
        country: "ksa",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 11,
        name: "Bassem Dghaidi",
        title: "Senior Solution Architect, GitHub",
        photo: bassem,
        country: "ksa",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 12,
        name: "Ahmed Farghal",
        title: "Staff Production Engineer at Meta",
        photo: farghal,
        country: "ksa",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 13,
        name: "Jeff Ghothelf",
        title: "Founder  of Gothelf.co",
        photo: jeff,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 14,
        name: "Amr Ali",
        title: "Senior Solutions Architect @Databricks",
        photo: amr_ali,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 15,
        name: "Mostafa Menessy",
        title: "Cofounder & CTO at Paymob",
        photo: mostafa_men,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 28,
        name: "Adham Fahmy",
        title: "CyberSecurity Director @Cysheild",
        photo: adham_fahmy,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },

    {
        id: 29,
        name: "Haitham Rwajbeh",
        title: "CEO @Falcons Soft Company",
        photo: Haitham_raj,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },

    {
        id: 30,
        name: "Andrew Hao",
        title: "Vice President Of Engineering at Bevy",
        photo: andy_hoa,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 16,
        name: "Mohamed Abdou",
        title: "Founder & CEO at Pravica",
        photo: abdo,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 17,
        name: "Habiba Mohamed Gadalla",
        title: "Frontend Tech Lead @ Halan",
        photo: habiba_gaddalah,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 18,
        name: "Saad Saleh",
        title: "CTO & Cofounder at DentaCarts",
        photo: Saad_Saleh,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 19,
        name: "Hithem Ahmed",
        title: "CTO - Cegedim",
        photo: hithem_ahmed,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 20,
        name: "Ashraf Bacheet",
        title: "CEO and Co-Founder, O7 Therapy",
        photo: noor_korayem,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 21,
        name: "Ahmad Alfy",
        title: "CTO Robusta",
        photo: Alfy,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 22,
        name: "Hend Ismail",
        title: "Tech lead and SW Consultant",
        photo: hend_ismail,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 23,
        name: "Marwan Naggar",
        title: "Senior Software Engineer at Google",
        photo: marwan_naggar,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 24,
        name: "Amira Badran",
        title: "Product Manager at Atlassian",
        photo: Amira_Badran,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 25,
        name: "Amani Hassan",
        title: "Founding Member at Egypt University of Informatics",
        photo: amani_hassan,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 26,
        name: "Amr Saleh",
        title: "CEO - Welnes",
        photo: Amr_saleh,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    },
    {
        id: 27,
        name: "Mohab Mohie",
        title: "Testing Senior Team Lead & Automation Specialist at _VOIS",
        photo: mohab_mohie,
        country: "jordan",
        brief: "from 75B! 75B is the Rotterdam based graphic design agency of Rens Muis and Steffen Knöll"
    }
];
